import React from "react";
import { Image, View } from "react-native";

export const ImageScreen = (props) => {
  const uri = props.route.params.uri;

  return (
    <View style={{ flex: 1 }}>
      <Image
        source={{ uri: uri }}
        style={{ width: "100%", height: "100%" }}
        resizeMode="contain"
      />
    </View>
  );
};
